export { DetailPageComponentModule } from "./detail-page-component.module";
export { DetailPageComponent } from "./detail-page.component";
